import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-client-filials",
  "use": "foquz-icon-client-filials-usage",
  "viewBox": "0 0 17 14",
  "content": "<symbol viewBox=\"0 0 17 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-client-filials\"><path d=\"M3 1V0a1 1 0 00-1 1h1zm11 0h1a1 1 0 00-1-1v1zm0 12v1h1v-1h-1zM3 13H2v1h1v-1zm-2-1a1 1 0 100 2v-2zm15 2a1 1 0 100-2v2zM3 2h11V0H3v2zm10-1v12h2V1h-2zm1 11H3v2h11v-2zM4 13V1H2v12h2zm-3 1h15v-2H1v2zm5-6v2h2V8H6zm3 0v2h2V8H9zM6 4v2h2V4H6zm3 0v2h2V4H9z\" fill=\"#73808D\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol